import React from 'react';
import { motion } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -15 }}
      transition={{ duration: 0.4, ease: [0.43, 0.13, 0.23, 0.96] }} // Cubic-bezier for smooth feel
      style={{ height: '100%', width: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
